module.exports = {
	websocketURL: typeof WS_URL !== 'undefined' ? WS_URL : null,
	dtzpIsInitialized: typeof DTZP_IS_INITIALIZED !== 'undefined' ? DTZP_IS_INITIALIZED : null,
	dtzpTimezone: typeof DTZP_TIMEZONE !== 'undefined' ? DTZP_TIMEZONE : null
};
